import { render, staticRenderFns } from "./BuyerServices.vue?vue&type=template&id=a47b6b98&scoped=true&"
import script from "./BuyerServices.vue?vue&type=script&lang=js&"
export * from "./BuyerServices.vue?vue&type=script&lang=js&"
import style0 from "./BuyerServices.vue?vue&type=style&index=0&id=a47b6b98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47b6b98",
  null
  
)

export default component.exports